import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Community } from '../data/schema/community';
import { CommunityService } from '../data/service/community.service';
import { ServiceHelper } from '../core/helper/services.helper';
import { Log } from '../core/log';


/**
 * This guard checks to see if the user has an active community. If not, send them to
 * My Communities, which itself will check to see if they have ANY communities, and if
 * not, takes them to the 'New Community' wizard.
 */
@Injectable()
export class CommunityGuard implements CanActivate {
    constructor( private router: Router, private communityService: CommunityService) { }

    async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // Log.debug('Community guard... ', next, state);
        if (Community.activeCommunity == null) {
            var currCommunityId = localStorage.getItem('curr_community');
            if ( currCommunityId == null ) {
                Log.debug('CommunityGuard - No curr_community stored, go to communities list');
                this.router.navigateByUrl('/home/communities');
                return false;
            }
            const community = await  this.communityService.loadCommunity(+currCommunityId);
            if ( community == null ) {
                
                Log.debug('CommunityGuard - Tried loading curr_community, returned null, wrong environment?');
                return false;
            }

            // check if community has completed setup, if not, take them to the new community
            // wizard to finish setup
            if ( community.templatesAdded == null ) {
                Log.debug('CommunityGuard - curr_community loaded, hasnt had template selected or skipped ');
                await ServiceHelper.displayAlert('Finish Setup', 
                    `Please finish setting up your community by selecting a template or selecting 'Start from Scratch'.`);
                this.router.navigateByUrl('/home/new-community/'+community.communityId);
            }
        }
        return true;
    }
}
